export default defineNuxtRouteMiddleware(async (to) => {
  const useSession = useSessionStore();
  const config = useRuntimeConfig();
  const useUser = useUserStore();

  if (
    config.public.sessionTimeoutRedirectURL !== to.path &&
    to.path !== '/access-code' &&
    to.path !== '/generate-error' &&
    to.path !== '/make-error' &&
    to.path !== '/pdf/summary' &&
    to.path !== '/pdf/audit-summary' &&
    to.path !== '/pdf/fpl-summary' &&
    to.path !== '/pdf/custom-form' &&
    to.path !== '/documents/preview'
  ) {
    if (to.path === '/applications/bulk-update-page') {
      localStorage.setItem('bulkUpdateInfo', 'false');
      return navigateTo('/applications/bulk-update?default-filter=true');
    }
    // Don't flip back to loading on later navigations: the default layout v-ifs on this flag, so
    // doing so unmounts the whole layout + page on every route change (even ?page=2 -> ?page=3),
    // remounting it against the old route and firing every query twice. It starts as true, which
    // still gates the first load until the token is validated.
    // Remember where the user was going so login can bring them back, whether they have
    // no token at all or a stale/expired one (the usual case on prod).
    const sendToLogin = async () => {
      // The SSO login always returns to one fixed host (VITE_ADMIN_URL). If the link was opened
      // on another host (e.g. the azurewebsites.net one), move there first so the redirect saved
      // below lives in the localStorage that /access-code will read after login.
      // Only for the external SSO login; local uses the in-app /access-code page.
      const externalLogin = !config.public.sessionTimeoutRedirectURL?.startsWith('/');
      const loginHostOrigin = getOrigin(config.public.adminUrl);
      if (externalLogin && loginHostOrigin && loginHostOrigin !== window.location.origin) {
        window.location.replace(loginHostOrigin + to.fullPath);
        return waitForUnload();
      }
      useSession.setRedirectPath(encodeURIComponent(to.fullPath));
      saveLoginRedirect(to.fullPath);
      await useSession.timeout();
      // The external login is a full page load that can take seconds to start. Keep this
      // navigation pending until then: if the page mounted, its failing (unauthenticated) calls
      // would navigate to '/' and overwrite the redirect we just saved.
      if (externalLogin) {
        return waitForUnload();
      }
    };

    const cookie = exportUserSession();
    if (cookie.value === undefined || cookie.value === null) {
      await sendToLogin();
      return;
    }

    try {
      await $fetch(`${config.public.legacyApiBase}/legacy/auth/validate-token`, {
        ...globalFetchOptions(),
        method: 'get',
      });
      useUser.setMiddlewareLoading(false);
    } catch (error) {
      await sendToLogin();
      return;
    }
  } /*else if () {
    useUser.setMiddlewareLoading(false);
  }*/ else {
    useUser.setMiddlewareLoading(false);
  }
});

// Never resolves: used while the browser leaves for another origin.
const waitForUnload = () => new Promise<never>(() => {});

const getOrigin = (url?: string) => {
  try {
    return url ? new URL(url).origin : '';
  } catch {
    return '';
  }
};
